import { Center, Link } from "@chakra-ui/react";
import { Link as ReactRouterLink } from 'react-router-dom';
import { routes } from 'utils';

const NavBar = () => {
    return (
      <Center>
        <Link as={ReactRouterLink} to={routes.PACKAGES.INDEX} color='primary.white' fontWeight={400} padding='0px 24px'>
          Trip Pack
        </Link>
        <Link as={ReactRouterLink} to={routes.STAYS.INDEX} color='primary.white' fontWeight={400} padding='0px 24px'>
          Stays
        </Link>
        <Link as={ReactRouterLink} to={routes.TICKETS.INDEX} color='primary.white' fontWeight={400} padding='0px 24px'>
          Tickets
        </Link>
        <Link as={ReactRouterLink} to={routes.EXPERIENCES.INDEX} color='primary.white' fontWeight={400} padding='0px 24px'>
          Experiences
        </Link>
      </Center>
    );
}

export { NavBar };